var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.11 27.58c7.502 1.871 15.098-2.693 16.968-10.193 1.87-7.5-2.694-15.098-10.195-16.968C10.385-1.451 2.788 3.114.92 10.615c-1.87 7.5 2.694 15.096 10.192 16.966Zm3.41-11.955c1.141 0 1.653-.03 1.752-.038h-.004c3.5-.156 6.111-.766 6.111-1.495 0-.73-2.611-1.34-6.11-1.496v2.384c-.099.01-.644.054-1.733.054-.907 0-1.564-.038-1.793-.055v-2.385c-3.507.157-6.125.767-6.125 1.498 0 .73 2.618 1.341 6.125 1.495.226.01.87.038 1.777.038Zm1.752-3.277v.001h-.001Zm0-2.133v2.133c3.961.184 6.938.969 6.938 1.91 0 .942-2.98 1.727-6.94 1.91v6.84h-3.528V16.17c-3.97-.184-6.954-.969-6.954-1.91 0-.943 2.985-1.73 6.954-1.912v-2.133H7.859V6.961h13.296v3.254h-4.884Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.3b1a9469e94a857df0e27e323306ae54.svg";
export { ForwardRef as ReactComponent };